// 内容(小说正文)多语言字体懒加载 —— 按作品语言(content_language)动态注入 public/fonts
// 下的自托管字体 CSS, 避免 Bun bundler 把 @font-face 字体内嵌进应用 CSS。
//
// 急加载已覆盖的脚本 (main.tsx): 拉丁(Geist) / 中文(Noto Sans SC) / 西里尔+越南扩展(Noto Sans) →
// 这些语言无需懒加载。其余脚本 (日/韩/阿/泰) 仅在 reader/内容区确定语言后按需加载, 避免首屏吞下全部 CJK。
//
// 与后端 internal/llm.LanguageNames + src/lib/contentLanguages.ts 的 14 语言集对齐。

// 已由 main.tsx 急加载覆盖的语言 (拉丁系 + 中文 + 西里尔), 无需再懒加载。
const EAGER_LANGS = new Set(['zh', 'en', 'fr', 'de', 'es', 'it', 'pt', 'id', 'ru', 'vi'])

const LAZY_FONT_HREFS: Record<string, string> = {
  ja: '/fonts/noto-sans-jp/index.css',
  ko: '/fonts/noto-sans-kr/index.css',
  ar: '/fonts/noto-sans-arabic/index.css',
  th: '/fonts/noto-sans-thai/index.css',
}

// 已加载语言 memoize, 防重复插入 link。
const loaded = new Set<string>()

export function injectFontLink(href: string): void {
  if (typeof document === 'undefined') return
  const exists = Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')).some(
    (link) => link.getAttribute('href') === href || link.dataset.nfFont === href,
  )
  if (exists) return

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = href
  link.dataset.nfFont = href
  document.head.appendChild(link)
}

/**
 * 确保指定作品语言所需的脚本字体已加载。
 * 急加载已覆盖或未知语言 → 直接返回 (no-op)。幂等, 可在每次内容/语言变化时安全调用。
 */
export function ensureContentLanguageFont(code?: string | null): void {
  if (!code) return
  const lang = code.toLowerCase().split('-')[0]
  if (EAGER_LANGS.has(lang) || loaded.has(lang)) return
  const href = LAZY_FONT_HREFS[lang]
  if (!href) return
  loaded.add(lang)
  injectFontLink(href)
}
